import {
  LayoutDashboard, ShoppingCart, Calculator, ClipboardList, ShieldCheck,
  BookOpen, ArrowLeftRight, Wrench, PackageCheck, Users, TreePine, Handshake, Building2, Table2, Warehouse, Wallet, Printer, DoorOpen, Bot, AlertTriangle,
} from "lucide-react";
import { rolesOf } from "@/context/AuthContext";

export const NAV = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, roles: null },
  { to: "/costing", label: "Product Costing", icon: Calculator, roles: ["admin", "manager"] },
  { to: "/finance", label: "Finance & P&L", icon: Wallet, roles: ["admin", "manager"] },
  { to: "/rate-sheets", label: "Rate Sheets", icon: Table2, roles: ["admin", "manager"] },
  { to: "/products", label: "Product Progress", icon: PackageCheck, roles: null },
  { to: "/ledgers", label: "Ledgers", icon: Building2, roles: ["admin", "manager", "store_keeper"] },
  { to: "/stores", label: "Stores", icon: Warehouse, roles: ["admin", "manager", "store_keeper"] },
  { to: "/shortages", label: "Shortage Inbox", icon: AlertTriangle, roles: ["admin", "manager", "store_keeper"] },
  { to: "/purchase-orders", label: "Purchase Orders", icon: ShoppingCart, roles: ["admin", "manager", "store_keeper"] },
  { to: "/sales-orders", label: "Sales Orders", icon: Handshake, roles: ["admin", "manager", "store_keeper"] },
  { to: "/operations", label: "Operations", icon: ClipboardList, roles: null },
  { to: "/quality-checks", label: "Quality Checks", icon: ShieldCheck, roles: null },
  { to: "/registers", label: "In / Out & Scrap", icon: ArrowLeftRight, roles: ["admin", "manager", "store_keeper"] },
  { to: "/gate", label: "Gate / Security", icon: DoorOpen, roles: ["admin", "manager", "store_keeper", "guard"] },
  { to: "/assistant", label: "AI Assistant", icon: Bot, roles: ["admin", "manager"] },
  { to: "/maintenance", label: "Maintenance", icon: Wrench, roles: null },
  { to: "/printing", label: "Printing", icon: Printer, roles: ["admin", "manager", "store_keeper"] },
  { to: "/guidelines", label: "Guidelines", icon: BookOpen, roles: null },
  { to: "/team", label: "Team", icon: Users, roles: ["admin", "manager"] },
];

export { TreePine };

export function navForRoles(roles) {
  const only = roles.length === 1 ? roles[0] : null;
  return NAV.filter((n) =>
    only === "guard" ? (n.roles || []).includes("guard") : (!n.roles || n.roles.some((r) => roles.includes(r)))
  );
}

export function navForUser(user) {
  const roles = rolesOf(user);
  let items = navForRoles(roles);
  const allowed = Array.isArray(user?.allowed_menus) && user.allowed_menus.length ? user.allowed_menus : null;
  if (allowed && !roles.includes("admin")) items = items.filter((n) => allowed.includes(n.to));
  return items;
}

export function canVisit(user, pathname) {
  const items = navForUser(user);
  const base = "/" + (pathname.split("/")[1] || "");
  return items.some((n) => n.to === base);
}

export function homeFor(user) {
  return navForUser(user)[0]?.to || "/";
}
